import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';


const BanaItem = (props: {
  img: string;
  title: string;
  desc: string;
  link: string;
}) => {
  const { img, title, desc, link } = props;

  const content = (
    <Fragment>
      <img className="thumbnail" src={img}></img>
      <div className="container">
        <p className="title">{title}</p>
        <p className="description">{desc}</p>
      </div>
    </Fragment>
  )

  return (
    <LinkButton>
      {link.includes('http')
        ? <a href={link} target='_blank'>{content}</a>
        : <Link to={link}>{content}</Link>}
    </LinkButton>
  );
};

BanaItem.defaultProps = {
  img: '',
  title: '',
  desc: '',
  link: '',
};

BanaItem.propTypes = {
  img: PropTypes.string,
  title: PropTypes.string,
  desc: PropTypes.string,
  link: PropTypes.string,
};

const LinkButton = styled.div`
  & a {
    width: 234px;
    height: 75px;
    outline: none;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
    font: 14px/100% Arial, Helvetica, sans-serif;
    -webkit-border-radius: 0.5em;
    -moz-border-radius: 0.5em;
    border-radius: 0.5em;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
    background: linear-gradient(#f1f1f1 0%, #fefefe 100%);
    display: flex;
    flex-direction: row;
    & :hover {
      text-decoration: none;
      background: linear-gradient(#fefefe 0%, #f1f1f1 100%);
    }
    & :active {
      position: relative;
      top: 1px;
    }
    & .thumbnail {
      height: 75px;
      margin: 6px;
      width: 63px;
      height: 63px;
    }
    & .container {
      height: 75px;
      padding: 2px;
    }
    & .container .title {
      padding-top: 8px;
      color: #005daa;
      font-weight: 900;
      font-size: 1.2em;
      width: 100%;
      text-align: left;
    }
    & .container .description {
      color: #111111;
      font-size: 0.8em;
      text-align: left;
      margin: 6px 0;
    }
  }
`;

export default BanaItem;
